import React, { forwardRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

interface ScrollableProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  hideTracksWhenNotNeeded?: boolean;
}

export const Scrollable = forwardRef<Scrollbars, ScrollableProps>(
  ({ children, style, hideTracksWhenNotNeeded = true }, ref) => {
    const isFixed = !!style?.height;
    const { maxHeight, ...styleWithoutMaxHeight } = style ?? {};
    const autoHeightMax = maxHeight ?? '100vh';

    return (
      <Scrollbars
        ref={ref}
        style={styleWithoutMaxHeight}
        hideTracksWhenNotNeeded={hideTracksWhenNotNeeded}
        autoHeight={!isFixed}
        autoHeightMin={isFixed ? undefined : 0}
        autoHeightMax={isFixed ? undefined : autoHeightMax}
      >
        {children}
      </Scrollbars>
    );
  },
);

Scrollable.displayName = 'Scrollable';
